import React from 'react';
import CommonButton from '@src/new-components/Button';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import Tooltip from '@src/components/Tooltip';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';
import { useTranslation } from 'react-i18next';
import { COLOR } from '@src/styles/color';
import { STEPS } from '@src/constants/instantVoiceCloning';
import { StyledActionsHeader } from './index.style';

const ActionsHeader = ({
  onSetStep,
  showReloadButton = false,
  onReload,
  onResetMetadataAudio,
  disabledButtonRefetch,
  prevStep,
}) => {
  const { t } = useTranslation();
  return (
    <StyledActionsHeader>
      <CommonButton
        startIcon={
          <ArrowBackRoundedIcon
            sx={{ fontSize: '24px !important', color: COLOR.darkBlue }}
          />
        }
        variant="outlineSmall"
        onClick={() => {
          onSetStep(prevStep || STEPS.UPLOAD_AUDIO);
          if (onResetMetadataAudio) {
            onResetMetadataAudio();
          }
        }}
        textProps={{
          variantText: 'body-14-medium',
          color: COLOR.darkBlue,
        }}
        customStyle={{
          height: '40px',
        }}
      >
        {t('back')}
      </CommonButton>
      {showReloadButton && (
        <CommonButton
          customStyle={{
            width: '40px',
            height: '40px',
            minWidth: '40px',
          }}
          variant="outlineSmall"
          onClick={onReload}
          disabled={disabledButtonRefetch}
        >
          <Tooltip arrow placement="top" title={t('changeSentence')}>
            <RefreshRoundedIcon
              sx={{ fontSize: '24px', color: COLOR.darkBlue }}
            />
          </Tooltip>
        </CommonButton>
      )}
    </StyledActionsHeader>
  );
};

export default ActionsHeader;
